import { ReactElement } from 'react';
import { Grid } from '@mui/material';
import { Controller } from 'react-hook-form';
import { ReactHookFormTextField } from 'Atoms';
import { FormattedMessage, useIntl } from 'react-intl';

export type RecrasCredentialFormProps = {
  prefix?: string | null;
};

const RecrasCredentialForm = ({
  prefix,
}: RecrasCredentialFormProps): ReactElement => {
  const intl = useIntl();

  return (
    // <Grid container spacing={2}>
    <>
      <Grid item xs={12}>
        <Controller
          name={prefix ? `${prefix}.name` : 'name'}
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={intl.formatMessage({ id: 'label.name' })}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={prefix ? `${prefix}.subDomain` : 'subDomain'}
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              label={<FormattedMessage id="label.subDomain" />}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={prefix ? `${prefix}.token` : 'token'}
          render={(registered) => (
            <ReactHookFormTextField
              {...registered}
              fullWidth
              type="password"
              label={<FormattedMessage id="label.token" />}
            />
          )}
        />
      </Grid>
    </>
    // </Grid>
  );
};

export default RecrasCredentialForm;
